import {Component, input, InputSignal, output, OutputEmitterRef} from '@angular/core';
import {EnumResponse} from '@core/models/enum-response';
import {getConcessionariaLogo, parseConcessionariaCode} from './concessionaria-logos';

@Component({
  selector: 'app-concessionaria-filter',
  imports: [],
  templateUrl: './concessionaria-filter.html',
  styleUrl: './concessionaria-filter.css'
})
export class ConcessionariaFilter {
  concessionarias: InputSignal<EnumResponse[]> = input<EnumResponse[]>([]);
  selected: InputSignal<string[] | null> = input<string[] | null>(null);

  toggle: OutputEmitterRef<string> = output<string>();
  clear: OutputEmitterRef<void> = output<void>();

  visible(): EnumResponse[] {
    return this.concessionarias().filter(c => this.codeFor(c.nome) !== null);
  }

  isSelected(nome: string): boolean {
    return !!this.selected()?.includes(nome);
  }

  hasSelection(): boolean {
    return !!this.selected()?.length;
  }

  logoFor(nome: string): string | null {
    return getConcessionariaLogo(nome);
  }

  codeFor(nome: string): string | null {
    return parseConcessionariaCode(nome);
  }
}
